// Composables
import {createRouter, createWebHistory, RouteRecordRaw, RouterOptions} from 'vue-router'
import { DialogRoute } from '@maru/hub-vuetify-components'

const history = createWebHistory(import.meta.env.BASE_URL)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        // just add redirect to survey consume as root is not being used, maybe later could be used with error message
      } as RouteRecordRaw,
      // {
      //   path: '/example',
      //   name: 'Example',
      //   component: () => import('@/views/Example.vue'),
      // },
      {
        path: '/preview-expired',
        name: 'PreviewExpired',
        component: () => import('@/views/PreviewExpired.vue')
      },
      {
        path: '/:sessionId',
        name: 'Survey',
        component: () => import('@/views/Survey.vue')
      }
    ],
  },
  {
    path: '/survey/:surveyId',
    name: 'EnterSurvey',
    component: () => import('@/views/EnterSurvey.vue')
  },
  {
    path: '/preview/:surveyId',
    name: 'PreviewSurvey',
    component: () => import('@/views/EnterSurvey.vue'),
    meta: {
      preview: true
    }
  },
  {
    path: '/preview/:surveyId/version/:versionId',
    name: 'PreviewVersion',
    component: () => import('@/views/EnterSurvey.vue'),
    meta: {
      preview: true,
      versionPreview: true
    }
  },
  DialogRoute.record // The shell's dialog frame, which m-dialogs render into
]

const router = createRouter({ history, routes } as RouterOptions)

// Update page title based on route
router.beforeEach((to, _from, next) => {
  if (to.name === 'Survey') {
    // Anonymous route - uses /:sessionId
    document.title = 'Survey participation'
  } else if (to.name === 'EnterSurvey' || to.name === 'PreviewSurvey' || to.name === 'PreviewVersion') {
    // Personalized links and IC distributions routes - uses /survey/:surveyId, /preview/:surveyId, or /preview/:surveyId/version/:versionId
    document.title = 'Survey participation'
  } else {
    // Default fallback
    document.title = 'Participation UI'
  }
  next()
})

export default router
